import { render, staticRenderFns } from "./PassingTimes.vue?vue&type=template&id=188f506f&scoped=true"
import script from "./PassingTimes.vue?vue&type=script&lang=js"
export * from "./PassingTimes.vue?vue&type=script&lang=js"
import style0 from "./PassingTimes.vue?vue&type=style&index=0&id=188f506f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f506f",
  null
  
)

export default component.exports